import useIntlContext from './use-intl.esm11.js';
import useTranslationsImpl from './use-intl.esm12.js';

/**
 * Translates messages from the given namespace by using the ICU syntax.
 * See https://formatjs.io/docs/core-concepts/icu-syntax.
 *
 * If no namespace is provided, all available messages are returned.
 * The namespace can also indicate nesting by using a dot
 * (e.g. `namespace.Component`).
 */
function useTranslations(namespace) {
  var context = useIntlContext();
  var messages = context.messages;
  // We have to wrap the actual hook so the type inference for the optional
  // namespace works correctly. See https://stackoverflow.com/a/71529575/343045
  // The prefix ("!") is arbitrary.
  return useTranslationsImpl({
    '!': messages
  },
  // @ts-expect-error
  namespace ? "!." + namespace : '!', '!');
}

export { useTranslations as default };
//# sourceMappingURL=use-intl.esm2.js.map
